// `window` is provided by ESLint's globals.browser preset (eslint.config.js).
/*
 * src/data/botLinks.js — single source of truth for the two HealBot Telegram bots.
 *
 * DO NOT hardcode `https://t.me/...` anywhere else in src/. Both bots are
 * tenants of our own platform (see docs/sale-desk-runbook.md):
 *
 *   salesBot — Sale Desk / Help Desk. Talks to clinic owners: pricing, features,
 *              GDPR, "how do I connect my bot". Tenant `kind = SALES`.
 *   demoBot  — patient-experience demo: one quiz funnel per direction
 *              (`?start=demo-<direction>`, seed: services/bot
 *              `pnpm seed:demo-funnels`). Tenant `kind = PATIENT`,
 *              `primaryDirection = mammo`.
 *
 * `payload` becomes the `?start=` deep-link parameter. The bot sanitizes it to
 * `[A-Za-z0-9_-]{1,64}`, stores it on the conversation and copies it into
 * `Lead.source` — so keep payloads inside that alphabet or attribution is lost.
 *
 * Two other places hold these handles as literals because they are outside the
 * bundle: `public/chatbots.html` (static page) and
 * `services/payments/src/templates/{success,failure}.ejs` (server-rendered).
 * Changing a handle here means changing them too.
 *
 * Wiring: this script MUST load BEFORE src/CtaBlock.jsx in src/main.entry.js.
 */
window.HEALBOT_BOT_LINKS = {
  salesBot: "healbot_ai_bot",
  demoBot: "demo_healbot",

  /** `tgLink("healbot_ai_bot", "site_cta")` → `https://t.me/healbot_ai_bot?start=site_cta` */
  tgLink(bot, payload) {
    const base = `https://t.me/${bot}`;
    return payload ? `${base}?start=${encodeURIComponent(payload)}` : base;
  },
};
